
import { Profile } from '@/types/auth';

export const getRedirectPath = (profile: Profile | null): string => {
  console.log('getRedirectPath - Profile:', {
    profileId: profile?.id,
    username: profile?.username,
    displayName: profile?.display_name,
    isCustomized: profile?.is_username_customized,
    hasCompletedOnboarding: profile?.has_completed_onboarding
  });
  
  // If no profile exists yet but we have an authentication, direct to create-username
  if (!profile) {
    console.log('getRedirectPath - No profile, redirecting to create-username');
    return '/create-username';
  }

  // If user has completed onboarding or has a custom username, they can proceed to bulletins
  if (profile.has_completed_onboarding || 
      (profile.username && !profile.username.startsWith('user_') && profile.is_username_customized)) {
    console.log('getRedirectPath - Has completed onboarding or has username, redirecting to bulletins');
    return '/bulletins';
  }
  
  // If username starts with 'user_' or is not marked as customized, redirect to username creation
  if (profile.username && 
      (profile.username.startsWith('user_') || !profile.is_username_customized)) {
    console.log('getRedirectPath - Has default username or not customized, redirecting to create-username');
    return '/create-username';
  }
  
  // Default fallback
  console.log('getRedirectPath - Default fallback, redirecting to bulletins');
  return '/bulletins';
};

/**
 * Helper function to determine if a username is temporary or invalid
 */
export const isTemporaryUsername = (username?: string): boolean => {
  if (!username) return true;
  return username.startsWith('user_') || username === 'anonymous';
};

/**
 * Helper function to get a display name fallback
 */
export const getDisplayNameFallback = (profile: Profile | null): string => {
  if (!profile) return 'User';
  
  if (profile.display_name) return profile.display_name;
  
  if (profile.username && !isTemporaryUsername(profile.username)) 
    return profile.username;
    
  // If we have a temporary username, try to extract a nicer name from it
  if (profile.username?.startsWith('user_')) {
    return 'User ' + profile.username.substring(5, 9).toUpperCase();
  }
  
  return 'User';
};
